<template>
  <div :class="['form-input', { 'has-error': hasError }]">
    <label v-if="label" :for="id">{{ label }}</label>
    <input
      :id="id"
      v-model="datetime"
      type="datetime-local"
      min="min"
      max="max"
    />
  </div>
</template>

<script>
/*
テキストボックスコンポーネント
[props]
  * value: v-modelでバインドされる要素
  * id: 要素のid。ラベル付与に必須
  * label: テキストボックス上部に付与されるラベル(未指定の場合非表示)
  * from: 指定可能日時(開始)
  * to: 指定可能日時(終了)
  * hasError: trueを指定するとエラースタイルが適用される
*/
export default {
  name: "ItemDateTimePicker",
  props: {
    value: {
      props: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    from: {
      type: String,
      required: false,
    },
    to: {
      type: String,
      required: false,
    },
    hasError: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    datetime: {
      get() {
        // datetime-localのvalueの書式は"YYYY-MM-DDThh:mm:ss"であるため、オフセット(+09:00)を削除
        return this.$moment(this.value).format("YYYY-MM-DDTHH:mm:ss");
      },
      set(value) {
        // 親コンポーネントにはオフセット(+09:00)を付けて渡す
        this.$emit("input", this.$moment(value).format());
      },
    },
  },
  mounted() {
    // 初期値があれば入れる
    this.text = this.value;
  },
};
</script>

<style lang="scss" scoped></style>
